"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCatalogAttributionsFromData = void 0;
const getCatalogAttributionsFromData = (data) => {
    var _a, _b, _c, _d, _e, _f;
    if (!data)
        return [];
    const edges = (_f = (_e = (_d = (_c = (_b = (_a = data.catalogs) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.attributions) === null || _e === void 0 ? void 0 : _e.edges) !== null && _f !== void 0 ? _f : [];
    const attributesByKey = (edges !== null && edges !== void 0 ? edges : []).reduce((acc, edge) => {
        const item = edge.node;
        if (!item)
            return acc;
        const key = `${item.attribute}::${item.type}`;
        if (!acc[key])
            acc[key] = item;
        return acc;
    }, {});
    const attributesList = Object.values(attributesByKey);
    return attributesList;
};
exports.getCatalogAttributionsFromData = getCatalogAttributionsFromData;
